import styled from "styled-components";

export const ExplanationParagraphs = styled.div`
	margin: 2em 0;
`;

export const ExplanationParagraph = styled.div`
	margin: 1em 0;
`;
